<template>
    <div class="">
      <button class="btn btn-primary" @click.prevent="resendFacultyEmail">Resend Faculty Advisor Email</button>
    </div>
</template>

<script>
    export default {
        props: ['actionurl', 'token'],
        methods: {
          resendFacultyEmail: function() {
                let that = this;
                window.axios(
                    {
                        method: 'put',
                        url: this.actionurl,
                        data: {
                            [that.machine_name]: that.status_to_update
                        }
                    }).then(function(response) {
                    let dataBack = response.data;
                    location.reload();
                });
            }
        }
    }

</script>
